import { render } from "./IconBusiness.vue?vue&type=template&id=743ff6ca"
import script from "./IconBusiness.vue?vue&type=script&lang=js"
export * from "./IconBusiness.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__